import React from 'react';
import { supabase } from '../lib/supabaseClient';

interface State {
  error: Error | null;
}

export default class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Application error:', error, info);
    supabase
      .rpc('log_client_error', {
        p_message: error.message || 'Unknown error',
        p_context: {
          stack: (error.stack || '').slice(0, 2000),
          component_stack: (info.componentStack || '').slice(0, 2000),
          path: typeof window !== 'undefined' ? window.location.pathname : '',
          user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
        },
      })
      .then(() => {})
      .catch(() => {});
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen grid place-items-center bg-warm-50 px-6">
          <div className="max-w-md text-center">
            <div className="text-xs uppercase tracking-wider text-ink-500 font-semibold mb-3">Something went wrong</div>
            <h1 className="font-display text-3xl mb-3">Sorry, that broke.</h1>
            <p className="text-ink-600 mb-6 text-sm">An unexpected error occurred. Reloading usually fixes it.</p>
            <button
              onClick={() => window.location.assign('/')}
              className="inline-flex items-center gap-2 bg-ink-900 text-warm-50 font-medium px-5 py-2.5 rounded-full hover:bg-ink-700 transition"
            >
              Reload PromptGPT
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
